<style scoped>
  .smileys-container {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    width: 25%;
    z-index: 1;
    pointer-events: none;
  }

  @keyframes slideBottomToTop {
    0% {
      opacity: 0;
    }

    10% {
      opacity: 1;
    }

    100% {
    transform: translateY(-100vh);
    opacity: 1;
    /*overflow: hidden;*/
    /*display: none;*/
    /*visibility: hidden;*/
  }
}

  .slide-enter-active {
    animation-duration: 10s;
    animation-name: slideBottomToTop;
    animation-fill-mode: backwards;
    animation-timing-function: ease-in;
  }
</style>

<template>
  <div
    v-if="visible"
    class="smileys-container"
  >
    <transition-group
    name="slide"
    v-on:after-enter="afterEnter"
  >
    <smiley
      v-for="smiley in smileys"
      :key="smiley.id"
      :id="smiley.id"
      :code="smiley.code"
      :right="smiley.right"
    />
      </transition-group>

  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
// import uuid from 'uuid-random'
import Smiley from './smiley'

export default {
  components: {
    Smiley
  },
  data() {
    return {
      visible: false,
      smileys: [],
    }
  },
  computed: {
    ...mapState({
      rooms: state => state.common.rooms,
    }),
    ...mapGetters({
      room: 'common/room',
      roomId: 'common/roomId'
    }),
  },
  methods: {
    receiveSmiley(data) {
      if(data.smiley.room_id == this.roomId) {
        data.smiley.right = `${_.random(0, 100)}%`
        this.smileys.push(data.smiley)
      }
    },
    afterEnter: function (el) {
      const { id } = el.__vue__
      _.remove(this.smileys, { id })
    },
  },
  mounted() {
    this.visible = _.clone(this.room.smileys_enabled)
    socket.on(`${EasyEvent.channel}:App\\Events\\NewSmiley`, this.receiveSmiley)
  },
  watch: {
    'room.smileys_enabled'(newVal) {
      const self = this
      switch(newVal) {
        case false:
          setTimeout(function() {
            self.visible = false
          }, 10000)
          break;
        default:
          self.visible = true
      }
    }
  }
}
</script>
